import { graphql } from 'react-relay';

export const itemListFragment = graphql`
  fragment ItemList_component on ItemList {
    id
    entries(first: 1000) {
      edges {
        node {
          ...ItemListEntry_component
        }
      }
    }
    smalllabel
  }
`;
